import { type Component, defineAsyncComponent } from "vue";

// Vite's CJS/ESM default-interop hands back the module namespace instead of
// the component for this package, so the static `import CircleProgress from
// "vue3-circle-progress"` renders as `<Module>` and Vue warns "Component is
// missing template or render function". A dynamic import with an explicit
// `.default` access resolves to the real component at render time.
export default defineAsyncComponent(() =>
  // @ts-expect-error - CJS-only package with no types for the /dist path
  import("vue3-circle-progress/dist/circle-progress.common.js").then(
    (mod: { default: Component }) => mod.default
  )
);
